import useGetUser from './useGetUser'

export default useGetUser
